import { ApiService } from './api';
import { Teacher } from '../types';

export interface AuthResponse {
  success: boolean;
  teacher: Teacher;
}

export interface RegisterResponse {
  success: boolean;
  teacher: Teacher;
}

export class AuthService {
  private static readonly TEACHER_STORAGE_KEY = 'ciar_teacher';
  private static readonly API_BASE = '/auth';

  // Sauvegarder les informations de l'enseignant dans le localStorage
  static saveTeacher(teacher: Teacher): void {
    try {
      localStorage.setItem(this.TEACHER_STORAGE_KEY, JSON.stringify(teacher));
    } catch (error) {
      console.error('Erreur sauvegarde enseignant:', error);
    }
  }

  // Récupérer les informations de l'enseignant depuis le localStorage
  static getTeacher(): Teacher | null {
    try {
      const stored = localStorage.getItem(this.TEACHER_STORAGE_KEY);
      console.log('stored', stored);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Erreur récupération enseignant:', error);
      return null;
    }
  }

  // Supprimer les informations de l'enseignant
  static clearTeacher(): void {
    try {
      localStorage.removeItem(this.TEACHER_STORAGE_KEY);
    } catch (error) {
      console.error('Erreur suppression enseignant:', error);
    }
  }

  // Vérifier si un enseignant est connecté
  static isTeacherLoggedIn(): boolean {
    return this.getTeacher() !== null;
  }

  // Connexion d'un enseignant
  static async loginTeacher(email: string, password: string): Promise<AuthResponse> {
    return ApiService.request<AuthResponse>(`${this.API_BASE}/teacher/login`, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  // Inscription d'un nouvel enseignant
  static async registerTeacher(name: string, email: string, password: string): Promise<RegisterResponse> {
    return ApiService.request<RegisterResponse>(`${this.API_BASE}/teacher/register`, {
      method: 'POST',
      body: JSON.stringify({ name, email, password }),
    });
  }

  // Obtenir les informations d'un enseignant
  static async getTeacherInfo(teacherId: string): Promise<{ success: boolean; teacher: Teacher }> {
    return ApiService.request<{ success: boolean; teacher: Teacher }>(`${this.API_BASE}/teacher/${teacherId}`);
  }

  // Mettre à jour les statistiques d'un enseignant
  static async updateTeacherStats(teacherId: string, sessionsIncrement: number = 0, studentsIncrement: number = 0): Promise<{ success: boolean; message: string }> {
    return ApiService.request<{ success: boolean; message: string }>(`${this.API_BASE}/teacher/${teacherId}/stats`, {
      method: 'PATCH',
      body: JSON.stringify({ sessionsIncrement, studentsIncrement }),
    });
  }

  // Déconnexion de l'enseignant
  static logoutTeacher(): void {
    this.clearTeacher();
    // Optionnel: rediriger vers la page d'accueil
    window.location.href = '/';
  }

  // Obtenir les statistiques formatées
  static getFormattedStats(teacher: Teacher): { sessions: string; students: string; lastLogin: string } {
    return {
      sessions: teacher.totalSessions.toString(),
      students: teacher.totalStudents.toString(),
      lastLogin: new Date(teacher.lastLoginAt).toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    };
  }
}
